// components/home/listings/guesthouse/GuestHouse.jsx
import React, { useState, useEffect } from 'react';
import { getAllHotels } from '../../../../api/hotel/hotelApi';
import HotelComponent from '../hotel/HotelComponent'; // Reuse the same component
import SearchBar from '../hotel/SearchBar';
import FilterModal from '../hotel/FilterModal';
import '../hotel/css/Hotel.css'; // Same CSS
import Loader from '../../../common/Loader.jsx';
import Error from '../../../common/Error.jsx';

const GuestHouse = () => {
    const [hotels, setHotels] = useState([]);
    const [filteredHotels, setFilteredHotels] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [filters, setFilters] = useState({
        name: '',
        city: '',
        location: '',
        minPrice: '',
        maxPrice: '',
        rating: '',
        amenities: []
    });

    useEffect(() => {
        const fetchGuestHouses = async () => {
            try {
                const response = await getAllHotels();
                if (response.success) {
                    // Filter for Guest Houses only
                    const guestHouses = response.data.filter(hotel => 
                        hotel.mainCategory === 'Guest House'
                    );
                    setHotels(guestHouses);
                    setFilteredHotels(guestHouses);
                }
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchGuestHouses();
    }, []);

    const handleSearch = (term) => {
        setSearchTerm(term);
        
        if (!term.trim() && Object.values(filters).every(val => 
            val === '' || (Array.isArray(val) && val.length === 0)
        )) {
            setFilteredHotels(hotels);
            return;
        }

        applyFilters(term, filters);
    };

    const applyFilters = (searchTerm, appliedFilters) => {
        let filtered = [...hotels];

        // Apply search term filter
        if (searchTerm.trim()) {
            filtered = filtered.filter(hotel =>
                hotel.hotelName.toLowerCase().includes(searchTerm.toLowerCase()) ||
                hotel.city.toLowerCase().includes(searchTerm.toLowerCase()) ||
                hotel.address?.toLowerCase().includes(searchTerm.toLowerCase())
            );
        }

        // Apply name filter
        if (appliedFilters.name) {
            filtered = filtered.filter(hotel =>
                hotel.hotelName.toLowerCase().includes(appliedFilters.name.toLowerCase())
            );
        }

        // Apply city filter
        if (appliedFilters.city) {
            filtered = filtered.filter(hotel =>
                hotel.city.toLowerCase().includes(appliedFilters.city.toLowerCase())
            );
        }

        // Apply location filter
        if (appliedFilters.location) {
            filtered = filtered.filter(hotel =>
                hotel.address?.toLowerCase().includes(appliedFilters.location.toLowerCase())
            );
        }

        // Apply price filter
        if (appliedFilters.minPrice || appliedFilters.maxPrice) {
            filtered = filtered.filter(hotel => {
                const minRoomPrice = Math.min(...hotel.rooms.map(room => room.pricePerNight));
                
                if (appliedFilters.minPrice && minRoomPrice < parseInt(appliedFilters.minPrice)) return false;
                if (appliedFilters.maxPrice && minRoomPrice > parseInt(appliedFilters.maxPrice)) return false;
                return true;
            });
        }

        // Apply rating filter
        if (appliedFilters.rating) {
            filtered = filtered.filter(hotel =>
                hotel.ratings?.average >= parseInt(appliedFilters.rating)
            );
        }

        // Apply amenities filter
        if (appliedFilters.amenities.length > 0) {
            filtered = filtered.filter(hotel =>
                appliedFilters.amenities.every(amenity =>
                    hotel.amenities?.includes(amenity)
                )
            );
        }

        setFilteredHotels(filtered);
    };

    const handleApplyFilters = (appliedFilters) => {
        setFilters(appliedFilters);
        applyFilters(searchTerm, appliedFilters);
    };

    if (loading) return <Loader />;
    if (error) return <Error errMessage={error}/>;

    return (
        <div className="fade-up hotel-listing-section">
            <h2 className='section-title'>
                Find Your Perfect Guest House
            </h2>
            
            {/* <SearchBar 
                onSearch={handleSearch}
                onFilterClick={() => setIsFilterModalOpen(true)}
                searchTerm={searchTerm}
            /> */}

            {/* <div className="results-info">
                {filteredHotels.length > 0 && (
                    <p className="results-count">
                        Showing {filteredHotels.length} of {hotels.length} guest houses
                    </p>
                )}
            </div> */}

            <div className="hotel-listings-container">
                {filteredHotels.length > 0 ? (
                    filteredHotels.map((hotel, index) => (
                        <HotelComponent
                            key={hotel._id}
                            id={hotel._id}
                            name={hotel.hotelName}
                            images={hotel.images}
                            city={hotel.city}
                            description={hotel.description}
                            rating={hotel.ratings?.average || 0}
                            ratingCount={hotel.ratings?.count || 0}
                            starRating={hotel.starRating}
                            rooms={hotel.rooms}
                            isFirst={index === 0}
                        />
                    ))
                ) : (
                    <div className="no-hotels">
                        <p>No guest houses match your search criteria.</p>
                        <button 
                            className="clear-filters-btn"
                            onClick={() => {
                                setSearchTerm('');
                                setFilters({
                                    name: '',
                                    city: '',
                                    location: '',
                                    minPrice: '',
                                    maxPrice: '',
                                    rating: '',
                                    amenities: []
                                });
                                setFilteredHotels(hotels);
                            }}
                        >
                            Clear all filters
                        </button>
                    </div>
                )}
            </div>

            {/* <FilterModal
                isOpen={isFilterModalOpen}
                onClose={() => setIsFilterModalOpen(false)}
                onApplyFilters={handleApplyFilters}
                filters={filters}
            /> */}
        </div>
    );
};

export default GuestHouse;